import CryptoJS   from "crypto-js"
import { apiConfig } from "../../config.js"
//var token= window.sessionStorage.getItem('token');
//token=token?token.substr(0,16):'abcdefghijklmnop';
var encryptkey=apiConfig.key
function Encrypt(word, keyStr){ 
    keyStr = keyStr ? keyStr : encryptkey;  
    var key  = CryptoJS.enc.Utf8.parse(keyStr);
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
    return encrypted.toString();
  }
  //解密
 function Decrypt (word, keyStr){  
    keyStr = keyStr ? keyStr : encryptkey;
    var key  = CryptoJS.enc.Utf8.parse(keyStr);
    var decrypt = CryptoJS.AES.decrypt(word, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  }

export { 
    Encrypt,
    Decrypt
}